import React, { useContext, useEffect, useLayoutEffect } from "react";
import './homeTopBarMobile.css'
import { useTopBarScrollState } from "../hookTopBar";
import TopBarHero from "./topBarHero";
import TopBarToolbar from "./topBarToolbar";
import { TopBarType } from "../homeTopBar";
import { AppContext } from "../../../../context/AppContext";
import { GoSearch } from "react-icons/go";
import { getInitialCurrentCity } from "../../SearchPage/hookSearchPage";
import { Restaurant } from "../../../../components/types/types";
import { trackSearchOpen } from "../../../../components/analytics/hookAnalytics";

interface TopBarPeekProps {
  visible: boolean;
  type:string,
  useMainFilter?:string,
}

const TopBarPeek: React.FC<TopBarPeekProps> = ({ type, useMainFilter='', visible }) => {
  const { setOpenSearchPage } = useContext(AppContext);
  
  return (
    <div className={`topBarPeek ${visible ? "isVisible" : ""}`} style={{"--peek-offset": visible ? "65px" : "0px",pointerEvents: visible ? "auto" : "none"} as React.CSSProperties}>
      <div className={`topBarMainButton smallText pointer flexAllCenter ${type} ${useMainFilter === '' ? 'isSimpleScnd' : 'isLongScnd'}`} onClick={() => {trackSearchOpen({action: type === "primary" ? "launch" : "modify",source: "peek"}); setOpenSearchPage(true);}}>
          <GoSearch className="iconFirst" size={18}/>
          <div className="scndPart flexAllCenter">
            {type === "primary"
              ? <span>Lancer ma recherche</span>
              : useMainFilter === '' ? 
                  <span>Modifier ma recherche</span> 
                  : <>
                    <span>{useMainFilter}</span>
                    <div>Modifier ma recherche</div>
                    <GoSearch className="iconScnd" size={18}/>
                  </>
            }
          </div>
        </div>


    </div>
  );


};


interface HomeTopBarMobileProps {
    type: TopBarType;
    fetchSections: (url: string,elem:string, options?: RequestInit, isInitialLoad?: boolean) => void;
    routeCity?:string;
    routeFilter?:string;
    hasNeighborHood: [string, string[][]][];
    resetHome:() => void,
    setShowAll: React.Dispatch<React.SetStateAction<number>>,
    baseSortSection:string,
    getNeighborhoodResultCount: (neighborhoods: string[]) => number;
    toolbarRestaurants: Restaurant[];
}
const HomeTopBarMobile:React.FC<HomeTopBarMobileProps> = ({type,fetchSections,baseSortSection,routeCity,routeFilter,hasNeighborHood,resetHome,setShowAll,getNeighborhoodResultCount,toolbarRestaurants}) => {
  const { indexablePages, connectionScreen,openSearchPage } = useContext(AppContext);
  const fullHeight = type === "primary" ? 260 : 150;

  let routeCityUse = routeCity ? (getInitialCurrentCity(routeCity, indexablePages)?.name || '') : '';
  const {  peekVisible, toolbarFixed  } = useTopBarScrollState(fullHeight);
  useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!meta) return;

    const shouldBeBlack = !toolbarFixed || peekVisible;

    meta.setAttribute("content", shouldBeBlack ? "#040404" : "#ffffff");

    return () => {
      meta.setAttribute("content", "#040404");
    };
  }, [toolbarFixed, peekVisible]);
  let useMainFilter =  routeCityUse || '';
  useMainFilter = (useMainFilter === 'Restaurants-A-Proximite' ? 'À proximité' : useMainFilter)

  const overlayOpen = connectionScreen || openSearchPage;
  const connectionWasToolbarFixedRef = React.useRef(false);
  const previousConnectionScreenRef = React.useRef(overlayOpen);
  const [keepToolbarFixed, setKeepToolbarFixed] = React.useState(false);

  useLayoutEffect(() => {
    const wasOpen = previousConnectionScreenRef.current;

    if (!wasOpen && overlayOpen) {
      connectionWasToolbarFixedRef.current = toolbarFixed;
    }

    if (wasOpen && !overlayOpen) {
      const wasFixed = connectionWasToolbarFixedRef.current;

      if (wasFixed) {
        setKeepToolbarFixed(true);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setKeepToolbarFixed(false);
            connectionWasToolbarFixedRef.current = false;
          });
        });
      } else {connectionWasToolbarFixedRef.current = false;}
    }

    previousConnectionScreenRef.current = overlayOpen;
  }, [overlayOpen]);
  const isToolbarFixed = toolbarFixed ||(overlayOpen &&connectionWasToolbarFixedRef.current) || keepToolbarFixed;
  return (
    <>
    <div className={`homeTopBar ${type}`}>
      <TopBarHero type={type} resetHome={resetHome} useMainFilter={useMainFilter}/>

      <div className={`topBarToolbarWrapper ${isToolbarFixed ? "isFixed" : ""} ${peekVisible ? "peekVisible" : ""}`} style={{"--peek-offset": peekVisible ? "65px" : "0px"} as React.CSSProperties}>
        <TopBarToolbar
          type={type}
          fetchSections={fetchSections}
          hasNeighborHood={hasNeighborHood ?? []}
          setShowAll={setShowAll}
          routeCity={routeCity}
          baseSortSection={baseSortSection}
          getNeighborhoodResultCount={getNeighborhoodResultCount}
          toolbarRestaurants={toolbarRestaurants}
          routeFilter={routeFilter}
        />
      </div>
    </div>

    <TopBarPeek type={type} visible={peekVisible} useMainFilter={useMainFilter}/>
    </>
  );
}

export default HomeTopBarMobile 